import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../services/api";

const initialState = {
  loading: false,
  registro: {},
  error: null,
};

export const fetchResults = createAsyncThunk(
  "fetchResults",
  async (params, thunkAPI) => {
    const { user_id, prop_id, plot_ter_id, plot_id, method, mode } = params;

    try {
      const response = await api.get(
        `/calculate/${user_id}/property/${prop_id}/plot-terrain/${plot_ter_id}/plot/${plot_id}?method=${method}&mode=${mode}`
      );

      let filename = response.headers["content-disposition"] || response.headers["Content-Disposition"]
      console.log(filename)
      return {
            data: response.data,
            filename: filename
            }
    } catch (err) {
      if (err.response?.status === 500) {
        return thunkAPI.rejectWithValue({
          message: `It was not possible to perform the calculations.\nReview the data and try again. (Error 500)`
        });
      }

      return thunkAPI.rejectWithValue({
        message: err.message || "Unexpected error occurred."
      });
    }
  }
);

export const slice = createSlice({
  name: "results",
  initialState,
  reducers: {
    resetResults: (state) => {
      state.registro = {};
      state.error = null;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchResults.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchResults.fulfilled, (state, action) => {
        state.loading = false;
        state.registro = action.payload;
        state.error = null;
      })
      .addCase(fetchResults.rejected, (state, action) => {
        state.loading = false;
        state.registro = {};
        state.error = action.payload?.message || "Unknown error.";
      });
  },
});

export const { resetResults } = slice.actions;
export default slice.reducer;
